import React, { useState } from 'react';
import FreeUsersTable from '../_components/free-users/page';
import { PageHeader } from '../../extras/PageLayout';
import { ResetFilterIcon } from '../../icons/enrolledUserIcons';
import Metrics from './_components/metrics';

export default function FreeUsersPage() {
  const [isApplyDefaultFilter, setIsApplyDefaultFilter] = useState(false);

  return (
    <div>
      <PageHeader title="Free Users" subtitle="Manage free users" />
      <Metrics />
      <div style={{ display: 'flex', gap: 16, alignItems: 'center', padding: '12px 0' }}>
        <button
          onClick={() => setIsApplyDefaultFilter(true)}
          style={{
            display: 'flex', gap: 6, alignItems: 'center',
            cursor: 'pointer', background: 'none', border: 'none', padding: 0,
            fontSize: 13, fontWeight: 600, color: 'var(--primary-main, #4F46E5)',
          }}
        >
          <ResetFilterIcon />
          Reset Filters
        </button>
      </div>
      <div style={{ padding: '0 0 24px' }}>
        <FreeUsersTable
          isApplyDefaultFilter={isApplyDefaultFilter}
          setIsApplyDefaultFilter={setIsApplyDefaultFilter}
        />
      </div>
    </div>
  );
}
